import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertLevel } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";

export class ActuatorOfflineToSecondary extends AlertLogic {
    static contentCategories = [ ContentCategories.EQUIPMENT_FAILURE ];
    static type:AlertType|AlertType[] = AlertType.ActuatorOfflineToSecondary;

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;

        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);

        const detailDescription3 = 
            config?.Config?.Settings?.IgnoreActuatorErrorsAndTurnOnPumps
            ? undefined
            : this.locale.gettext('Pumps will not run until this is addressed.')
        ;
        const detailDescription4 = 
            config?.Config?.FreezeProtect.Mode !== Config.FreezeProtectModes.DISABLED
            ? this.locale.gettext('Please note that this alert is ignored when Freeze Protect is running.')
            : undefined
        ;
        
        let actionTitle = '';
        let action:any = false;

        // Varying across alert types
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Actuator Offline'),
            cardDescription: this.locale.gettext('%1$s cannot be controlled', device.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'actuator3',
            detailDescription: this.locale.gettext('Valve actuator "%1$s" plugged into port %2$s of your secondary Attendant cannot be controlled because the secondary Attendant is offline.',
                device.Name,
                device.HardwareDevice.Ports[0]?.Number || this.locale.gettext('Unknown')
            ),
            detailDescription2: this.locale.gettext('Please confirm the secondary Attendant is powered on and correctly connected.'),
            detailDescription3,
            detailDescription4,
            actionButtonTitle: actionTitle,
            actionButtonAction: action,
            resolveSummary: this.locale.gettext('Connection to %1$s restored', device.Name)
        });
        alertInfo.contentCategories = ActuatorOfflineToSecondary.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device:Partial<Config.DeviceConfig> = config?.Config?.Devices.find(dev => dev.DeviceType === "ActuatorThreeWay") || 
                        config?.Config?.Devices.find(dev => dev.DeviceType === "ActuatorTwoWay");
        device = device;
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type.toString().replace('ACTUATOR_', '')),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: config?.Config?.BodiesOfWater[0]?.UUID,
            level: AlertLevel.Error,
            type: type,
            data: {
                
            }
        }) : null;
    }
}